import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";

import { Provider } from "react-redux";
import store from "./store/store";

import "./libs.min.css";
import "./index.sass";
import App from "./App";

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter basename="/account">
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);
